<template>
  <center>
    <div class="login-form">
      <img id="logo" class="mb-4" draggable="false" src='logo.png'>
        <div class="form-group mb-4">
          <input class="form-control text-center" type="text" placeholder="username" v-model.trim="username">
        </div>
        <div class="form-group mb-4">
          <input class="form-control text-center" type="password" placeholder="Password" v-model.trim="password" @keyup.enter="login()">
        </div>
        <div class="form-group mb-4">
          <button class="btn btn-romanfly w-100" :disabled="loading" @click="login()">
            <span v-if="loading" class="spinner-border"></span>
            <span>Log in</span>
          </button>
        </div>
        <p>Copyright © 2025 Romanfly</p>
    </div>
  </center>
</template>
<!-- ******************************************************** -->
<script>
  export default {
    name: 'LoginPage',
    data(){
      return {
        username: '',
        password: '',
        loading: false,
      }
    },
    methods:{
      async login(){
        this.loading = true;
        await this.loginAction();
        this.loading = false;
      },
      async loginAction(){
        if(!this.username) return this.$toast('Username is required!', 'warning');
        if(!this.password) return this.$toast('Password is required!', 'warning');
        //--------------------------------------------------------------------------------------------
        var res = await this.$service.login({
          'username': this.username,
          'password': this.password,
        })
        if(res.state != 'OK') return this.$toast(res.state, 'error');
        if(!res.data.token) return this.$toast('Invalid Credentials', 'error');
        // this.$toast('Logged In: '+res.token, 'success');
        await this.$store.dispatch('userData', res.data);
        this.$router.replace('/profile');
        //--------------------------------------------------------------------------------------------
      }
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
.login-form{
    width: 90%;
    max-width: 400px;
    background: #f7f7f7;
    padding: 30px 30px 30px 30px;
    margin-top: 15vh;
    position: relative;
}
.login-form p:last-child{
    position: absolute;
    display: block;
    width: 100%;
    color: white;
    font-size: 11pt;
    background-color:  rgba(0, 0, 0, 0.35);
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    margin: 0;
    line-height: 10pt;
    padding: 4px;
}
.login-form #logo{
    /* position: absolute; */
    top: 25px;
    right: 25px;
    left: 25px;
    width: 100%;
    margin: auto;
    height: auto;
}
</style>
  